import { SCOPE_HINT, SCOPE_LABEL } from "../../lib/explorer";
import type { DataScope } from "../../types/explorer";
import { GlossaryLink } from "../GlossaryLink";

export function ScopeBadge({
  scope,
  linkToGlossary = true,
}: {
  scope: DataScope;
  /** Set false when nested inside another interactive element (e.g. a button). */
  linkToGlossary?: boolean;
}) {
  const isExtended = scope === "extended-2026";
  const hint = SCOPE_HINT[scope];
  const termId = isExtended ? "new-2026" : "validated-thesis";
  const className = [
    "inline-flex items-center gap-1.5 border px-2.5 py-0.5 text-[11px] font-semibold",
    isExtended
      ? "rounded-md border-info/55 bg-info/15 text-info"
      : "rounded-full border-accent/45 bg-accent/10 text-accent",
  ].join(" ");

  const content = (
    <>
      <span aria-hidden="true" className="font-bold">
        {isExtended ? "✦" : "✓"}
      </span>
      {SCOPE_LABEL[scope]}
    </>
  );

  if (!linkToGlossary) {
    return (
      <span
        title={hint}
        aria-label={`${SCOPE_LABEL[scope]}. ${hint}`}
        className={className}
      >
        {content}
      </span>
    );
  }

  return (
    <GlossaryLink
      termId={termId}
      title={`${hint} Definition on Science.`}
      className={`${className} hover:opacity-90`}
      aria-label={`${SCOPE_LABEL[scope]}. ${hint}`}
    >
      {content}
    </GlossaryLink>
  );
}
